import React from "react";
import styles from "./GlossarFilter.module.scss";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNextButton,
  CarouselPrevButton,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import useWindowSize from "@/hooks/useWindowSize";
import { useGrid } from "@aleksundshantu/aunds-utils-react/primitives/grid";

interface GlossarFilterProps {
  activeLetter: string;
  setActiveLetter: (activeLetter: string) => void;
  extraClasses?: string;
}

export const GlossarFilter = ({
  activeLetter,
  setActiveLetter,
  extraClasses = "",
}: GlossarFilterProps) => {
  const { width } = useWindowSize();
  const isSlider = width < 1287;

  const { extraData } = useGrid();
  const filterChars = extraData?.filterChars || {};
  const letters = Object.values(filterChars);

  return (
    <div
      data-is-slider={isSlider}
      className={`${styles["glossar-filter"]} ${extraClasses}`}
    >
      {isSlider ? (
        <GlossarFilterSlider
          setActiveLetter={setActiveLetter}
          activeLetter={activeLetter}
          letters={letters}
        />
      ) : (
        <>
          <Letter
            activeLetter={activeLetter}
            letter={"Alle"}
            setValue={"all"}
            onClick={() => setActiveLetter("all")}
          />
          {letters.map((letter, key) => (
            <Letter
              activeLetter={activeLetter}
              key={key}
              letter={letter}
              setValue={letter}
              onClick={() => setActiveLetter(letter)}
            />
          ))}
        </>
      )}
    </div>
  );
};

const Letter = ({
  letter,
  activeLetter,
  setValue,
  onClick,
}: {
  letter: string;
  setValue: string;
  activeLetter: string;
  onClick?: () => void;
}) => {
  const { setItems, setTotalPosts, setCurrentPage } = useGrid();

  const onClickHandler = () => {
    setCurrentPage(1);
    setItems([]);
    setTotalPosts(-1);
    if (onClick) onClick();
  };

  return (
    <button
      type="button"
      data-is-active={activeLetter === setValue}
      className={styles["letter"]}
      onClick={onClickHandler}
    >
      {letter}
    </button>
  );
};
interface GlossarFilterSliderProps extends GlossarFilterProps {
  letters: string[];
}
const GlossarFilterSlider = ({
  letters,
  activeLetter,
  setActiveLetter,
}: GlossarFilterSliderProps) => {
  return (
    <Carousel align={"start"} dragFree>
      <CarouselPrevButton />
      <CarouselContent extraContainerClasses="p-0" spacing="20px">
        <CarouselItem itemWidth={"auto"} itemHeight={"auto"}>
          <Letter
            activeLetter={activeLetter}
            letter={"Alle"}
            setValue={"all"}
            onClick={() => setActiveLetter("all")}
          />
        </CarouselItem>
        {letters.map((letter, key) => (
          <CarouselItem itemWidth={"auto"} itemHeight={"auto"} key={key}>
            <Letter
              activeLetter={activeLetter}
              letter={letter}
              setValue={letter}
              onClick={() => setActiveLetter(letter)}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselNextButton />
    </Carousel>
  );
};
